import checkExistence from '@nykaa/auth-shared/store/actions/checkExistence';
import { logger } from '@nykaa/logger';
import { isPhoneNumber } from '@nykaa/auth-shared/utils';
import { getGoogleConnectUrl } from '@nykaa/auth-shared/store/utils';
import {
  CHECK_EXISTANCE_CAPTCHA_ERROR,
  recaptchaActions,
} from '@nykaa/auth-shared/constants';
import { CheckExistenceServiceProps } from '@nykaa/auth-shared/store/types';
import executeCaptcha from '@nykaa/auth-shared/utils/reCaptcha';
import {
  removeAuthFromStorage,
  setAuthSteps,
} from '@nykaa/auth-data-handler/store/helper';
import { GetLoginProps } from '@nykaa/auth-shared/types';
import { loginPageName } from 'components/Header/RightNav/KebabMenu/SignUp/helper';
import { getMobileNumberLocal } from 'helpers/auth';
import {
  ACCOUNT,
  LOGIN_WIDGET,
  NEW,
  SIGNUP_PAGE_NAME,
  WELCOME_PAGE,
  WELCOME_SCREEN,
} from 'constants/auth';
import { pushEvent } from '@nykaa/data-layer';
import { useSelector } from 'react-redux';
import { State } from 'store/types';
import { useHistory } from 'react-router-dom';
import { useEffect } from 'react';

const API_KEY = process.env.G_RECAPTCHA_V3;

export const getLogin = ({
  emailPhone,
  history,
  dispatch,
  setErrorMessage,
  setError,
  name,
  sendOtpToMail,
  isCheckExistenceCaptchaEnabled,
}: GetLoginProps) => {
  let checkExistenceParams: CheckExistenceServiceProps = {
    history,
  };
  const sentOnPhone = isPhoneNumber(emailPhone);
  if (!sentOnPhone) {
    checkExistenceParams = {
      ...checkExistenceParams,
      email: emailPhone,
    };
  } else {
    checkExistenceParams = {
      ...checkExistenceParams,
      mobile_number: emailPhone,
      name,
      sendOtpToMail,
    };
  }
  if (isCheckExistenceCaptchaEnabled) {
    executeCaptcha(recaptchaActions.CHECK_EXISTENCE, API_KEY)
      .then((token: string) => {
        setError(false);
        const captchaParams = {
          captchaResponse: token,
        };
        checkExistenceParams = {
          ...captchaParams,
          ...checkExistenceParams,
        };
        checkExistence(checkExistenceParams)(dispatch);
      })
      .catch((err: Error) => {
        setError(true);
        setErrorMessage(err.message);
        logger.error(err, CHECK_EXISTANCE_CAPTCHA_ERROR);
      });
  } else checkExistence(checkExistenceParams)(dispatch);
};

export const handleSocialLogin = () => {
  const { googleAppId = '' } = process.env;
  const googleUrl = getGoogleConnectUrl(googleAppId, false);
  localStorage.setItem('googleLoginAttempt', 'true');
  removeAuthFromStorage();
  setAuthSteps(2);
  if (googleUrl) {
    window.location.href = googleUrl;
  }
};

export const handleWelcomeScreenEvent = (history: History) => {
  const { search: queryString } = history.location;
  const queryParams = new URLSearchParams(queryString);
  const root = queryParams.get('root');
  const phFill = getMobileNumberLocal() ? 1 : 0;
  const localPageLocation = loginPageName();
  const pageLocation = `${localPageLocation}:${LOGIN_WIDGET}`;
  const pageName = SIGNUP_PAGE_NAME;
  pushEvent(WELCOME_SCREEN, {
    pageLocation,
    pageName,
    phFill,
    page: WELCOME_SCREEN,
    pageType: WELCOME_PAGE,
    interactionLocation: `${localPageLocation}:${root || ACCOUNT.default}`,
    nudge_screen_load_location: localPageLocation,
    welcome_screen_type: NEW,
  });
};
export const useManageEvents = () => {
  const isDataFetched = useSelector((state: State) => state.auth.dataFetched);
  const history = useHistory();
  useEffect(() => {
    if (isDataFetched) {
      const handleLoad = () => {
        handleWelcomeScreenEvent(history);
      };
      const timer = setTimeout(() => {
        handleLoad();
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [isDataFetched, history]);
};
